import { withAuthenticationRequired } from '@auth0/auth0-react';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { api } from "../../../services/api";
import { Alert, CardBody, Form, Spinner } from 'reactstrap';
import Loading from '../../../components/Loading';
import VolverButton from '../../../components/VolverButton';
import { useTranslation } from 'react-i18next';
import './cuentas.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { Avatar, Card, Tab, Tabs, CardHeader, FormControl, FormControlLabel, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Radio, RadioGroup } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { toast } from 'react-toastify';
import PagoTicModal from '../../../components/modales/PagoTicModal';
import PagoTIC from "../../../assets/favicon-pagotic.png";
import { Add } from '@mui/icons-material';
import PVSModal from '../../../components/modales/PVSModal';

function VincularCuentas() {
  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null
  });
  const param = useParams();
  const [t] = useTranslation("global");
  const [loading, setLoading] = useState(false);
  const [loadingLink, setLoadingLink] = useState(false);
  const [vinculacion, setVinculacion] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = anchorEl;
  const [value, setValue] = useState(0);

  const [showPayPerTicModal, setShowPayPerTicModal] = useState(false);
  const [showPVSModal, setShowPVSModal] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /*  console.log("datos: ", vinculacion); */


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const callApi = async (id) => {
    setLoading(true);
    try {
      const response = await api.eventoCuentas.getAll(id);

      if (response.status === "success") {
        setVinculacion(response.data.vinculacion);
      }
      else {
        throw new Error(response.message);
      }

    } catch (error) {
      setState({
        ...state,
        error: error.message
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    document.title = `Carteras | PassGo`;
    callApi(param.id);
  }, [param.id]);

  const handleGenerateLink = async () => {
    setLoadingLink(true);

    try {
      const idevento = parseInt(param?.id);

      const response = await api.mercadopago.vincularCuenta({
        idevento: idevento,
      });

      if (response.status === "success") {
        window.location = response.data;
      }
    } catch (error) {
      setState({
        ...state,
        error: error
      });
    } finally {
      setLoadingLink(false);
    }
  }

  const handleDesvincularMP = async () => {
    try {
        setLoadingLink(true);
        let response;
            response = await api.mercadopago.desvincularCuenta(param.id);

        

        if (response.status === "success") {
            toast.success("Cuenta desvinculada exitosamente");
            handleClose();
            callApi(param.id);
        }
    } catch (error) {
        toast.error(error.message || "Error al desvincular la cuenta");
    } finally {
        setLoadingLink(false);
    }
};

const handleDesvincularPagoTIC = async () => {
  try {
      setLoadingLink(true);
      let response;
          response = await api.pagotic.unlinkCredential(param.id);


      if (response.status === "success") {
          toast.success("Cuenta desvinculada exitosamente");
          handleClose();
          callApi(param.id);
      }
  } catch (error) {
      toast.error(error.message || "Error al desvincular la cuenta");
  } finally {
      setLoadingLink(false);
  }
};

  return (
    <>
      <div style={{ backgroundColor: "white", height: "100%", width: "100%", borderTop: "1px solid rgb(228, 228, 231)", padding: "20px" }}>
        <p style={{ fontSize: "18px" }}>Conecta tus carteras para recibir los fondos de tus eventos</p>
        <div>
          <div className='d-flex flex-column align-items-center' style={{  }}>
            <div className='d-flex flex-row align-items-center' style={{ maxWidth:"700px", padding: "20px", border: "1px solid #AEAEAE", borderRadius: "10px" }}>
              <div>
                <img src='/mp-icon.png' alt='mercado pago' style={{ width: "60px", height: "60px" }} />
              </div>
              <div className='d-flex flex-column' style={{ marginLeft: "20px" }}>
                <p>Cuenta de Mercado Pago</p>
                <p>Titular: {vinculacion?.titular || 'No vinculado'}</p>
                <p></p>
              </div>
            </div>

              {/* <div className='d-flex flex-column align-items-center' style={{ padding: "20px" }}>
                {!vinculacion?.mercado_pago && (
                  <MercadoPagoForm handleGenerateLink={handleGenerateLink} loadingLink={loadingLink} />
                )}
                <Card sx={{ minWidth: 300, maxWidth: 600, boxShadow: 'none', border: `2px solid ${vinculacion?.mercado_pago ? '#008000' : '#AEAEAE'}` }}>
                  <CardHeader
                    avatar={<Avatar src="/mp-icon.png" sx={{ width: 60, height: 60 }} />}
                    action={vinculacion?.mercado_pago && <IconButton onClick={handleClick}><MoreVertIcon /></IconButton>}
                    title="Cuenta de Mercado Pago"
                    subheader={
                      <div className="d-flex flex-column">
                        <span>Titular: {vinculacion?.titular || 'No vinculado'}</span>
                        <span>Estado: <i className="fw-bold">{vinculacion?.mercado_pago ? "VINCULADO" : "NO VINCULADO"}</i></span>
                      </div>
                    }
                  />
                </Card>
              </div>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              <MenuItem onClick={handleDesvincularMP}>
                <ListItemIcon><DeleteForeverIcon fontSize="small" /></ListItemIcon>
                <ListItemText>Desvincular</ListItemText>
              </MenuItem>
            </Menu> */}
            
              <div className='d-flex flex-column align-items-center' style={{ padding: "20px" }}>
                  {!vinculacion?.pagotic && (
                    <div className='d-flex flex-row justify-content-end align-items-end w-100'>
                    <button type="button" style={{backgroundColor:"#5656FF"}} onClick={() => setShowPayPerTicModal(true)} className="btn btn-primary my-3" disabled={loadingLink}><Add/> Conectar cuenta</button>
                  </div>
                  )}
                <Card sx={{ minWidth: 300, maxWidth: 600, boxShadow: 'none', border: `2px solid ${vinculacion?.pagotic ? '#008000' : '#AEAEAE'}` }}>
                  <CardHeader
                    avatar={<Avatar src={PagoTIC} /* sx={{ width: 60, height: 60 }} */ />}
                    action={vinculacion?.pagotic && <IconButton onClick={handleClick}><MoreVertIcon /></IconButton>}
                    title="Cuenta de PagoTIC"
                    subheader={
                      <div className="d-flex flex-column">
                        <span>Nombre: {vinculacion?.pagotic?.nombre || 'No vinculado'}</span>
                        <span>Estado: <i className="fw-bold">{vinculacion?.pagotic ? "VINCULADO" : "NO VINCULADO"}</i></span>
                      </div>
                    }
                  />
                </Card>
              </div>
            <PagoTicModal
              open={showPayPerTicModal}
              onClose={() => setShowPayPerTicModal(false)}
              loading={loadingLink}
            />

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              <MenuItem onClick={handleDesvincularPagoTIC}>
                <ListItemIcon><DeleteForeverIcon fontSize="small" /></ListItemIcon>
                <ListItemText>Desvincular</ListItemText>
              </MenuItem>
            </Menu>

            <div className='d-flex flex-column align-items-center' style={{ padding: "20px" }}>
                  {!vinculacion?.pvs && (
                    <div className='d-flex flex-row justify-content-end align-items-end w-100'>
                    <button type="button" style={{backgroundColor:"#5656FF"}} onClick={() => setShowPVSModal(true)} className="btn btn-primary my-3" disabled={loadingLink}><Add/> Conectar cuenta</button>
                  </div>
                  )}
                <Card sx={{ minWidth: 300, maxWidth: 600, boxShadow: 'none', border: `2px solid ${vinculacion?.pagotic ? '#008000' : '#AEAEAE'}` }}>
                  <CardHeader
                    avatar={<Avatar src={PagoTIC} /* sx={{ width: 60, height: 60 }} */ />}
                    action={vinculacion?.pvs && <IconButton onClick={handleClick}><MoreVertIcon /></IconButton>}
                    title="Cuenta de pvs"
                    subheader={
                      <div className="d-flex flex-column">
                        <span>Nombre: {vinculacion?.pvs?.nombre || 'No vinculado'}</span>
                        <span>Estado: <i className="fw-bold">{vinculacion?.pvs ? "VINCULADO" : "NO VINCULADO"}</i></span>
                      </div>
                    }
                  />
                </Card>
              </div>
            <PVSModal
              open={showPVSModal}
              onClose={() => setShowPVSModal(false)}
              loading={loadingLink}
            />

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              <MenuItem onClick={handleDesvincularPagoTIC}>
                <ListItemIcon><DeleteForeverIcon fontSize="small" /></ListItemIcon>
                <ListItemText>Desvincular</ListItemText>
              </MenuItem>
            </Menu>


            <div className="container d-flex justify-content-end">
              <VolverButton />
            </div>
          </div>
        </div>

      </div>


      {/* <div>
      <div className="d-flex justify-content-center gap-4">
        {!loading ? (
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="mercado_pago"
              name="radio-buttons-group"
            >
              <FormControlLabel
                value="mercado_pago"
                control={<Radio />}
                disabled={vinculacion}
                label={
                  <Card
                    sx={{
                      minWidth: 150,
                      boxShadow: 'none',
                      border: `2px solid ${!vinculacion ? '#AEAEAE' : '#008000'}`,
                      backgroundColor: `${vinculacion && '#71BC7810'}`  
                    }}>
                    <CardHeader
                      avatar={
                        <Avatar
                          src="/mp-icon.png"
                          alt="mercado pago"
                          sx={{
                            width: 100,
                            height: 100,
                            backgroundColor: 'transparent',
                          }}
                          aria-label="recipe">
                        </Avatar>
                      }
                      action={
                        <>
                          <IconButton
                            disabled={!vinculacion}
                            className="ms-2"
                            aria-label="settings"
                            onClick={handleClick}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'left',
                            }}
                            aria-label="short-menu"
                          >
                            <MenuItem onClick={() => handleDesvincular(vinculacion?.id)}>
                              <ListItemIcon>
                                <DeleteForeverIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>Desvincular</ListItemText>
                            </MenuItem>
                          </Menu>
                        </>
                      }
                      title={<p className="fs-5">Cuenta de Mercado Pago</p>}
                      subheader={
                        <div className="d-flex flex-column">
                          <span>Titular: {vinculacion?.titular}</span>
                          <span>Estado: <i className="fw-bold">{vinculacion ? vinculacion.mercado_pago : "NO VINCULADO"}</i></span>
                        </div>
                      }
                    />
                  </Card>
                }
              />
            </RadioGroup>
          </FormControl>
        ) : (
          <Spinner color="primary" />
        )}
      </div>
      
      {!vinculacion && !loading &&
        <MercadoPagoForm
          handleGenerateLink={handleGenerateLink}
          loadingLink={loadingLink}
        />
      }
    
      <div className="container d-flex justify-content-end">
        <VolverButton />
      </div>
    </div> */}
    </>
  )

}


function MercadoPagoForm({ handleGenerateLink, loadingLink }) {
  return (
    <div className='d-flex flex-row justify-content-end align-items-end w-100'>
      <button type="button" style={{backgroundColor:"#5656FF"}} onClick={handleGenerateLink} className="btn btn-primary my-3" disabled={loadingLink}><Add/> Conectar cuenta</button>
    </div>

  );
}

export default withAuthenticationRequired(VincularCuentas, {
  onRedirecting: () => <Loading />,
});